import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type CampaignsAnalytics = {
  id: number;
  campaign: { name: string; scheduled: string; user_email: string };
  channel: 'push' | 'sms' | null;
  messages_sent: number | null;
  conversion_rate: number | null;
  total_revenue: number | null;
  sends: number | null;
};

export type CampaignsAnalyticsResponseType = CampaignsAnalytics[];

export const useGetCampaignsAnalytics = (
  options: QueryOptions<
    CampaignsAnalyticsResponseType,
    AxiosError<ApiError>
  > = {}
) =>
  useQuery({
    queryFn: async (): Promise<CampaignsAnalyticsResponseType> => {
      const { data } = await api.get<
        ApiResponse<CampaignsAnalyticsResponseType>
      >(`/campaign/analytics/list`);

      return data.data;
    },
    queryKey: ['campaigns', 'analytics'],
    ...options,
  });
